import { fontSizes, fontWeights } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

const colorVars = {
  lightGrayBorder: '#d8d8d8',
  darkGrayBorder: '#cacad1',
  lightGrayText: '#8c8c8c',
  medGrayText: '#585858',
  emojiGray: '#50555c',
  chevronGray: '#222324',
  moreGray: '#231f20',
}

const headerWrapper = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: colors.n10.base,
  padding: '16px 14px 16px 10px',
  fontWeight: fontWeights.bold,
  borderBottom: `1px solid ${colorVars.lightGrayBorder}`,
  borderRadius: '5px 5px 0 0',
  '.kuiper-icon-sms-west-chevron': {
    color: colorVars.chevronGray,
  },
  '.kuiper-icon-sms-more': {
    color: colorVars.moreGray,
  },
}

const smsPreviewWrapper = {
  height: '543px',
  overflow: 'auto',
  padding: '16px 20px 16px 68px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
}

const messageBoxWrapper = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  height: '71px',
  borderRadius: '0 0 5px 5px',
  borderTop: `1px solid ${colorVars.darkGrayBorder}`,
  backgroundColor: colors.n8.base,
}

const messageBox = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  width: '323px',
  borderRadius: '8px',
  padding: '15px 16px 11px 12px',
  backgroundColor: colors.n10.base,
}

const messageBoxInner = {
  color: colorVars.medGrayText,
  fontSize: fontSizes.large,
  display: 'flex',
  alignItems: 'center',
  '.kuiper-icon-sms-emoji': {
    color: colorVars.emojiGray,
  },
  '.kuiper-icon-sms-plus': {
    color: colorVars.lightGrayText,
  },
}

const messageBoxText = {
  paddingLeft: '15px',
}

const styles = {
  headerWrapper,
  smsPreviewWrapper,
  messageBoxWrapper,
  messageBox,
  messageBoxInner,
  messageBoxText,
}

export { styles }
